var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
/**
 * Public branding context for the embedded booking widget (PRD #1358, RS-005).
 *
 * The widget reads this at boot — scoped SOLELY by the embed session, never an
 * office id from the caller — and maps it onto CSS custom properties. Only the
 * two skinnable values leave the backend: the practice's primary colour and an
 * API-relative path to its (already `@Public()`) logo endpoint. Nothing else
 * about the office location is exposed.
 *
 * `primaryColor` is null when the practice has configured none — the widget
 * then keeps its neutral built-in default rather than rendering broken.
 * `logoPath` is null when no logo is uploaded, so the widget shows no logo at
 * all instead of the Therame fallback the logo endpoint would otherwise serve.
 */
export class PublicOfficeLocationBrandingDto {
    primaryColor;
    /**
     * API-relative path to the public logo (`office-location-branding/:id/logo`),
     * or null when the practice has uploaded no logo. Relative so the widget
     * prefixes its own API root — the backend does not know the public host.
     */
    logoPath;
}
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PublicOfficeLocationBrandingDto.prototype, "primaryColor", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PublicOfficeLocationBrandingDto.prototype, "logoPath", void 0);
//# sourceMappingURL=public-office-branding.dto.js.map